
import { SubscriptionPlan } from '@/types/subscriptionPlans';

// Helper to classify features
export const classifyFeatures = (features: { name: string, included: boolean }[]) => {
  const keyFeatureKeywords = ['refer', 'manager', 'link', 'domain', 'white', 'integration'];
  
  const keyFeatures: typeof features = [];
  const otherFeatures: typeof features = [];
  
  features.forEach(feature => {
    const isKeyFeature = keyFeatureKeywords.some(keyword => 
      feature.name.toLowerCase().includes(keyword)
    );
    
    if (isKeyFeature) {
      keyFeatures.push(feature);
    } else {
      otherFeatures.push(feature);
    }
  });
  
  return { keyFeatures, otherFeatures };
};

// Get billing information based on billing cycle
export const getPlanPrice = (
  plan: SubscriptionPlan,
  billingCycle: 'monthly' | 'quarterly' | 'yearly'
) => {
  let price = plan.monthlyPrice;
  let billingLabel = "/month";
  
  if (billingCycle === "quarterly") {
    price = plan.quarterlyPrice;
    billingLabel = "/quarter";
  } else if (billingCycle === "yearly") {
    price = plan.yearlyPrice || plan.monthlyPrice * 12 * 0.8; // 20% discount if yearlyPrice not specified
    billingLabel = "/year";
  }
  
  return { price, billingLabel };
};
